<ion-list lines="none" class="w-full flex flex-col gap-4 py-4">
  <ion-item class="input-label">
    <ion-input
      type="text"
      fill="outline"
      label="Lien de la vidéo Youtube"
      label-placement="floating"
      color="primary"
      [(ngModel)]="videoLink"
      (ionChange)="onInputChange()"
    ></ion-input>
    <p *ngIf="invalidLink" class="text-red-500 italic mt-2">Veuillez saisir un lien youtube valide</p>
  </ion-item>
</ion-list>